<section class="required-document">
  <p class="title">{{ requiredFileTitle | translate }}</p>

  @if (document) {
    <div class="document">
      <div class="icon-wrapper">
        <mat-icon>description</mat-icon>
      </div>
      <div class="details">
        <p #nameEl class="name" matTooltip="{{ document.name }}" [matTooltipDisabled]="!isNameEllipsisActive" (mouseenter)="checkEllipsis(nameEl)">{{ document.name }}</p>
        <p class="type">{{ documentFormat }}</p>
      </div>
      <button mat-icon-button (click)="onDownloadClick()">
        <mat-icon class="material-symbols-outlined">download</mat-icon>
      </button>
      <button mat-icon-button (click)="onDeleteClick()">
        <mat-icon class="material-symbols-outlined">delete</mat-icon>
      </button>
    </div>
  } @else {
    <div class="upload-document pointer" (click)="fileInput.click()">
      <mat-icon>add</mat-icon>
      <p>{{ 'transcriber.upload' + documentType | translate }}</p>
    </div>
  }
</section>

@if (allowOptionalFiles) {
  <section class="optional-documents">
    <p class="title">{{ optionalFilesTitle | translate }}</p>

    <div class="optional-documents-list">
      @for (file of optionalDocuments; track file.name + '-' + $index) {
        <div class="document">
          <div class="icon-wrapper">
            <mat-icon>description</mat-icon>
          </div>
          <div class="details">
            <p #optionalNameEl class="name" matTooltip="{{ file.name }}" [matTooltipDisabled]="!optionalEllipsisStates[$index]" (mouseenter)="checkEllipsis(optionalNameEl, $index)">{{ file.name }}</p>
            <p class="type">{{ getDocumentFormat(file) }}</p>
          </div>
          <button mat-icon-button (click)="onDownloadOptionalClick($index)">
            <mat-icon class="material-symbols-outlined">download</mat-icon>
          </button>
          <button mat-icon-button (click)="onDeleteOptionalClick($index)">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
          </button>
        </div>
      }

      @if (optionalDocuments.length < maxOptionalDocuments) {
        @if (optionalDocuments.length === 0) {
          <div class="upload-document pointer" (click)="optionalFileInput.click()">
            <mat-icon>add</mat-icon>
            <p>{{ 'upload.buttonLabel' | translate }}</p>
          </div>
        } @else {
          <div
            class="upload-document upload-document--compact pointer"
            (click)="optionalFileInput.click()"
          >
            <mat-icon>add</mat-icon>
          </div>
        }
      }
    </div>
  </section>
}

<input
  #fileInput
  style="display: none"
  type="file"
  (change)="onFileSelected($event)"
  accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
/>

<input
  #optionalFileInput
  style="display: none"
  type="file"
  multiple
  (change)="onOptionalFilesSelected($event)"
  accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
/>
